// CNS OBJECT EXTENSION
// FOR MODALS
; (({ $ }) => {
    const page = $('#page')
    const overlay = $('#overlay')

    const pageLockedClass = 'page_locked'
    const overlayShownClass = 'overlay_shown'
    const modalShownClass = 'js-modal-shown'
    const triggerActiveClass = 'js-trigger-active'

    CNS.$modals.shownModals = {
        selectors: [],
        triggers: []
    }

    const openModal = (selector, trigger, showOverlay = false, lockPage = false, zOverlay = 90, callbackBefore = null, callbackAfter = null) => {
        const modal = $(selector)

        if (typeof callbackBefore == 'function') {
            callbackBefore(modal, trigger, overlay)
        }

        if (modal) {
            modal.classList.add(modalShownClass)
            CNS.$modals?.shownModals?.selectors?.push(selector)
        }

        if (lockPage && page) {
            page.classList.add(pageLockedClass)
        }

        if (showOverlay && overlay) {
            overlay.classList.add(overlayShownClass)
            overlay.style.zIndex = zOverlay
        }

        if (trigger) {
            trigger.classList.add('js-trigger-active')
            CNS.$modals?.shownModals?.triggers?.push(trigger)
        }

        if (typeof callbackAfter == 'function') {
            callbackAfter(modal, trigger, overlay)
        }
    }

    const closeModal = (selector, trigger, callbackBefore = null, callbackAfter = null, closeOverlay = true) => {
        const modal = $(selector)

        if (typeof callbackBefore == 'function') {
            callbackBefore(modal, trigger, overlay)
        }

        if (modal) {
            modal.classList.remove(modalShownClass)
            CNS.$modals.shownModals.selectors = CNS.$modals?.shownModals?.selectors.filter(el => el != selector)
        }

        if (page) {
            page.classList.remove(pageLockedClass)
        }

        if (overlay && closeOverlay) {
            overlay.classList.remove(overlayShownClass)
        }

        if (trigger) {
            trigger.classList.remove(triggerActiveClass)
            CNS.$modals.shownModals.triggers = CNS.$modals.shownModals.triggers.filter(el => el != trigger)
        }

        if (typeof callbackAfter == 'function') {
            callbackAfter(modal, trigger, overlay)
        }

        if (window.livewire) {
            window.livewire.emit('closeAllModals')
        }
    }

    const closeAllModals = (callbackBefore = null, callbackAfter = null) => {
        if (typeof callbackBefore == 'function') {
            callbackBefore(null, null, overlay)
        }

        const clonedSelectors = [...CNS.$modals.shownModals.selectors]
        clonedSelectors.forEach(selector => closeModal(selector))

        CNS.$modals.shownModals.triggers.forEach(trigger => trigger.classList.remove(triggerActiveClass))

        CNS.$modals.shownModals = {
            selectors: [],
            triggers: []
        }

        if (page) {
            page.classList.remove(pageLockedClass)
        }

        if (overlay) {
            overlay.classList.remove(overlayShownClass)
        }

        if (typeof callbackAfter == 'function') {
            callbackAfter(null, null, overlay)
        }
    }

    if (overlay) {
        overlay.addEventListener('click', () => closeAllModals())
    }

    CNS.$modals.openModal = openModal
    CNS.$modals.closeModal = closeModal
    CNS.$modals.closeAllModals = closeAllModals
})(CNS);


; (({ $, $$ }) => {
    // Touch Panel
    const panelMenuOpenTrigger = $('#panel-menu-open-trigger')

    CNS.$fns.openPanelMenu = () => {
        CNS.$modals.closeAllModals()
        CNS.$modals.openModal('#panel-menu', panelMenuOpenTrigger, true, true)
    }

    CNS.$fns.closePanelMenu = () => {
        CNS.$modals.closeModal('#panel-menu', panelMenuOpenTrigger)
    }

    if (panelMenuOpenTrigger) {
        panelMenuOpenTrigger.addEventListener('click', () => {
            if (panelMenuOpenTrigger.classList.contains('js-trigger-active')) {
                // close the touch panel
                CNS.$fns.closePanelMenu()
            } else {
                // open the touch panel
                CNS.$modals.closeAllModals()
                CNS.$fns.openPanelMenu()
            }
        })
    }

    // Leads filter
    CNS.$fns.openModalLeadsFilter = () => {
        CNS.$modals.openModal('#modal-leads-filter', null, true, true)
    }

    CNS.$fns.closeModalLeadsFilter = () => {
        CNS.$modals.closeModal('#modal-leads-filter')
    }

    const modalLeadsFilterOpenTriggers = document.querySelectorAll('.js-modal-leads-filter-opener')
    const modalLeadsFilterCloseTriggers = document.querySelectorAll('.js-modal-leads-filter-closer')

    Array.from(modalLeadsFilterOpenTriggers).forEach(trigger => {
        trigger.addEventListener('click', () => CNS.$modals.openModal('#modal-leads-filter', trigger, true, true))
    })

    Array.from(modalLeadsFilterCloseTriggers).forEach(trigger => {
        trigger.addEventListener('click', () => CNS.$modals.closeModal('#modal-leads-filter', trigger))
    })

    // saved filters
    CNS.$fns.openModalLeadsSavedFilters = () => {
        CNS.$modals.openModal('#modal-saved-filters')
    }

    CNS.$fns.closeModalLeadsSavedFilters = () => {
        CNS.$modals.closeModal('#modal-saved-filters')
    }

    const modalLeadsSavedFiltersToggler = document.querySelectorAll('.js-modal-saved-filters-toggler')
    const modalLeadsSavedFiltersCloser = document.querySelectorAll('.js-modal-saved-filters-closer')

    modalLeadsSavedFiltersToggler.forEach(toggler => {
        toggler.addEventListener('click', () => {
            if (toggler.classList.contains('js-trigger-active')) {
                CNS.$modals.closeModal('#modal-saved-filters', toggler, () => {
                    modalLeadsSavedFiltersToggler.forEach(el => el.classList.remove('js-trigger-active'))
                }, null, false)
            } else {
                CNS.$modals.openModal('#modal-saved-filters', toggler)
            }
        })
    })

    modalLeadsSavedFiltersCloser.forEach(closer => {
        closer.addEventListener('click', () => {
            CNS.$modals.closeModal('#modal-saved-filters', null, () => {
                modalLeadsSavedFiltersToggler.forEach(el => el.classList.remove('js-trigger-active'))
            }, null, false)
        })

    })


    // Leads sorter
    CNS.$fns.openModalLeadsSorter = () => {
        CNS.$modals.openModal('#modal-leads-sorter', null, true, true)
    }

    CNS.$fns.closeModalLeadsSorter = () => {
        CNS.$modals.closeModal('#modal-leads-sorter')
    }

    const modalLeadsSorterOpenTriggers = document.querySelectorAll('.js-modal-leads-sorter-opener')
    const modalLeadsSorterCloseTriggers = document.querySelectorAll('.js-modal-leads-sorter-closer')

    Array.from(modalLeadsSorterOpenTriggers).forEach(trigger => {
        trigger.addEventListener('click', () => CNS.$modals.openModal('#modal-leads-sorter', trigger, true, true))
    })

    Array.from(modalLeadsSorterCloseTriggers).forEach(trigger => {
        trigger.addEventListener('click', () => CNS.$modals.closeModal('#modal-leads-sorter', trigger))
    })

    // Lead search mobile
    // CNS.$fns.openModalLeadsSearchMobile = () => {
    //     CNS.$modals.openModal('.js-modal-leads-search-mobile', null, true, true)
    // }

    // CNS.$fns.closeModalLeadsSearchMobile = () => {
    //     CNS.$modals.closeModal('.js-modal-leads-search-mobile')
    // }

    // const modalLeadsSearchMobileOpenTriggers = document.querySelectorAll('.js-modal-leads-search-opener')
    // const modalLeadsSearchMobileCloseTriggers = document.querySelectorAll('.js-modal-leads-search-closer')

    // Array.from(modalLeadsSearchMobileOpenTriggers).forEach(trigger => {
    //     trigger.addEventListener('click', () => CNS.$modals.openModal('.js-modal-leads-search-mobile', trigger, true, true))
    // })

    // Array.from(modalLeadsSearchMobileCloseTriggers).forEach(trigger => {
    //     trigger.addEventListener('click', () => CNS.$modals.closeModal('.js-modal-leads-search-mobile', trigger))
    // })

    // Quick lead
    CNS.$fns.openModalQuickLead = () => {
        CNS.$modals.openModal('.js-modal-quick-lead')
    }

    CNS.$fns.closeModalQuickLead = () => {
        CNS.$modals.closeModal('.js-modal-quick-lead')
    }

    // Panel notifications
    const panelNotificationOpenTriggers = $$('.panel-notifications-open-trigger')
    let panelNotificationCloseTriggers = $$('.panel-notifications-close-trigger')

    CNS.$fns.openPanelNotifications = (trigger = null) => {
        CNS.$modals.closeAllModals()
        CNS.$modals.openModal('#panel-notifications', trigger, true, true)

        panelNotificationOpenTriggers.forEach(trigger => trigger.classList.add('js-trigger-active'))

        const panelMenu = $('#panel-menu')
        if (panelMenu) {
            panelMenu.classList.add('panel-menu_over-overlay')
        }
    }

    CNS.$fns.closePanelNotifications = (trigger = null) => {
        CNS.$modals.closeModal('#panel-notifications', trigger)

        panelNotificationOpenTriggers.forEach(trigger => trigger.classList.remove('js-trigger-active'))

        const panelMenu = $('#panel-menu')
        if (panelMenu) {
            panelMenu.classList.remove('panel-menu_over-overlay')
        }
    }

    panelNotificationOpenTriggers.forEach(trigger => {
        trigger.addEventListener('click', () => {
            if (trigger.classList.contains('js-trigger-active')) {
                // close the touch panel
                CNS.$fns.closePanelNotifications(trigger)
            } else {
                // open the touch panel
                CNS.$modals.closeAllModals()
                CNS.$fns.openPanelNotifications(trigger)
            }
        })
    })

    const overlay = $$('#overlay')
    panelNotificationCloseTriggers = [
        ...panelNotificationCloseTriggers,
        ...(overlay ? overlay : [])
    ]

    panelNotificationCloseTriggers.forEach(trigger => {
        trigger.addEventListener('click', () => {
            CNS.$fns.closePanelNotifications(trigger)
        })
    })


    // passed

    // Confirm modal
    CNS.$fns.openModalConfirm = () => {
        CNS.$modals.openModal('.js-modal-confirm', null, true, true)
    }

    CNS.$fns.closeModalConfirm = () => {
        CNS.$modals.closeModal('.js-modal-confirm')
    }

    const modalConfirmCloseTriggers = document.querySelectorAll('.js-modal-confirm-close-trigger')
    Array.from(modalConfirmCloseTriggers).forEach(trigger => {
        trigger.addEventListener('click', () => CNS.$fns.closeModalConfirm())
    })

    // Loading
    CNS.$fns.openModaLoading = () => {
        CNS.$modals.openModal('.js-modal-loading', null, true, true)
    }

    CNS.$fns.testLivewire = () => {
        window.livewire.emit('say-hello', { name: 'John' });
    }

    CNS.$fns.closeModaLoading = () => {
        CNS.$modals.closeModal('.js-modal-loading')
    }

    const modalLoadingOpenTriggers = document.querySelectorAll('.js-modal-loading-open-trigger')
    const modalLoadingCloseTriggers = document.querySelectorAll('.js-modal-loading-close-trigger')

    Array.from(modalLoadingOpenTriggers).forEach(trigger => {
        trigger.addEventListener('click', () => CNS.$modals.openModal('.js-modal-loading', trigger, true, true))
    })

    Array.from(modalLoadingCloseTriggers).forEach(trigger => {
        trigger.addEventListener('click', () => CNS.$modals.closeModal('.js-modal-loading', trigger))
    })

    // Cargo
    CNS.$fns.openModalCargo = () => {
        CNS.$modals.openModal('.js-modal-cargo', null, true, true)
    }

    CNS.$fns.closeModalCargo = () => {
        CNS.$modals.closeModal('.js-modal-cargo')
    }

    const modalCargoOpenTriggers = document.querySelectorAll('.js-modal-cargo-open-trigger')
    const modalCargoCloseTriggers = document.querySelectorAll('.js-modal-cargo-close-trigger')

    Array.from(modalCargoOpenTriggers).forEach(trigger => {
        trigger.addEventListener('click', () => CNS.$modals.openModal('.js-modal-cargo', trigger, true, true))
    })

    Array.from(modalCargoCloseTriggers).forEach(trigger => {
        trigger.addEventListener('click', () => CNS.$modals.closeModal('.js-modal-cargo', trigger))
    })

    // Collective Cargo
    CNS.$fns.openModalCollectiveCargo = () => {
        CNS.$modals.openModal('.js-modal-collective-cargo', null, true, true)
    }

    CNS.$fns.closeModalCollectiveCargo = () => {
        CNS.$modals.closeModal('.js-modal-collective-cargo')
    }

    const modalCollectiveCargoOpenTriggers = document.querySelectorAll('.js-modal-collective-cargo-open-trigger')
    const modalCollectiveCargoCloseTriggers = document.querySelectorAll('.js-modal-collective-cargo-close-trigger')

    Array.from(modalCollectiveCargoOpenTriggers).forEach(trigger => {
        trigger.addEventListener('click', () => CNS.$modals.openModal('.js-modal-collective-cargo', trigger, true, true))
    })

    Array.from(modalCollectiveCargoCloseTriggers).forEach(trigger => {
        trigger.addEventListener('click', () => CNS.$modals.closeModal('.js-modal-collective-cargo', trigger))
    })

    // Conditions
    CNS.$fns.openModalContractConditions = () => {
        CNS.$modals.openModal('#modal-contract-conditions', null, true, true)
    }

    CNS.$fns.closeModalContractConditions = () => {
        CNS.$modals.closeModal('#modal-contract-conditions')
    }

    const modalConditionsOpenTriggers = document.querySelectorAll('.js-modal-contract-conditions-open-trigger')
    const modalConditionsCloseTriggers = document.querySelectorAll('.js-modal-contract-conditions-close-trigger')

    Array.from(modalConditionsOpenTriggers).forEach(trigger => {
        trigger.addEventListener('click', () => CNS.$modals.openModal('#modal-contract-conditions', trigger, true, true))
    })

    Array.from(modalConditionsCloseTriggers).forEach(trigger => {
        trigger.addEventListener('click', () => CNS.$modals.closeModal('#modal-contract-conditions', trigger))
    })

    // Change lead status
    CNS.$fns.openModalChangeStatus = () => {
        CNS.$modals.openModal('#js-modal-change-status', null, true, true)
    }

    CNS.$fns.closeModalChangeStatus = () => {
        CNS.$modals.closeModal('#js-modal-change-status')
    }

    const modalChangeStatusOpenTriggers = document.querySelectorAll('.js-modal-lead-status-open-trigger')
    const modalChangeStatusCloseTriggers = document.querySelectorAll('.js-modal-lead-status-close-trigger')

    Array.from(modalChangeStatusOpenTriggers).forEach(trigger => {
        trigger.addEventListener('click', () => CNS.$modals.openModal('#js-modal-change-status', trigger, true, true))
    })

    Array.from(modalChangeStatusCloseTriggers).forEach(trigger => {
        trigger.addEventListener('click', () => CNS.$modals.closeModal('#js-modal-change-status', trigger))
    })

    // Take in work lead modal
    CNS.$fns.openModalTakeInWork = () => {
        CNS.$modals.openModal('#js-modal-takeinwork', null, true, true)
    }

    CNS.$fns.closeModalTakeInWork = () => {
        CNS.$modals.closeModal('#js-modal-takeinwork')
    }

    const modalTakeinworkOpenTriggers = document.querySelectorAll('.js-modal-takeinwork-open-trigger')
    const modalTakeinworkCloseTriggers = document.querySelectorAll('.js-modal-takeinwork-close-trigger')

    Array.from(modalTakeinworkOpenTriggers).forEach(trigger => {
        trigger.addEventListener('click', () => CNS.$modals.openModal('#js-modal-takeinwork', trigger, true, true))
    })

    Array.from(modalTakeinworkCloseTriggers).forEach(trigger => {
        trigger.addEventListener('click', () => CNS.$modals.closeModal('#js-modal-takeinwork', trigger))
    })

    // Copy lead
    CNS.$fns.openModalCopyLead = () => {
        CNS.$modals.openModal('#js-modal-copylead', null, true, true)
    }

    CNS.$fns.closeModalCopyLead = () => {
        CNS.$modals.closeModal('#js-modal-copylead')
    }

    const modalCopyLeadOpenTriggers = document.querySelectorAll('.js-modal-copylead-open-trigger')
    const modalCopyLeadCloseTriggers = document.querySelectorAll('.js-modal-copylead-close-trigger')

    Array.from(modalCopyLeadOpenTriggers).forEach(trigger => {
        trigger.addEventListener('click', () => CNS.$modals.openModal('#js-modal-copylead', trigger, true, true))
    })

    Array.from(modalCopyLeadCloseTriggers).forEach(trigger => {
        trigger.addEventListener('click', () => CNS.$modals.closeModal('#js-modal-copylead', trigger))
    })

    // LeadAccess
    CNS.$fns.openModalLeadAccess = () => {
        CNS.$modals.openModal('#js-modal-leadaccess', null, true, true)
    }

    CNS.$fns.closeModalLeadAccess = () => {
        CNS.$modals.closeModal('#js-modal-leadaccess')
    }

    const modalLeadaccessOpenTriggers = document.querySelectorAll('.js-modal-leadaccess-open-trigger')
    const modalLeadaccessCloseTriggers = document.querySelectorAll('.js-modal-leadaccess-close-trigger')

    Array.from(modalLeadaccessOpenTriggers).forEach(trigger => {
        trigger.addEventListener('click', () => CNS.$modals.openModal('#js-modal-leadaccess', trigger, true, true))
    })

    Array.from(modalLeadaccessCloseTriggers).forEach(trigger => {
        trigger.addEventListener('click', () => CNS.$modals.closeModal('#js-modal-leadaccess', trigger))
    })

    // LeadSupport
    CNS.$fns.openModalLeadSupport = () => {
        CNS.$modals.openModal('.js-modal-leadsupport', null, true, true)
    }

    CNS.$fns.closeModalLeadSupport = () => {
        CNS.$modals.closeModal('.js-modal-leadsupport')
    }

    const modalLeadsupportOpenTriggers = document.querySelectorAll('.js-modal-leadsupport-open-trigger')
    const modalLeadsupportCloseTriggers = document.querySelectorAll('.js-modal-leadsupport-close-trigger')

    Array.from(modalLeadsupportOpenTriggers).forEach(trigger => {
        trigger.addEventListener('click', () => CNS.$modals.openModal('.js-modal-leadsupport', trigger, true, true))
    })

    Array.from(modalLeadsupportCloseTriggers).forEach(trigger => {
        trigger.addEventListener('click', () => CNS.$modals.closeModal('.js-modal-leadsupport', trigger))
    })

    // Contragent create modal
    CNS.$fns.openModalCompanycreate = () => {
        CNS.$modals.openModal('.js-modal-companycreate', null, true, true)
    }

    CNS.$fns.closeModalCompanycreate = () => {
        CNS.$modals.closeModal('.js-modal-companycreate')
    }

    const modalCompanycreateOpenTriggers = document.querySelectorAll('.js-modal-companycreate-open-trigger')
    const modalCompanycreateCloseTriggers = document.querySelectorAll('.js-modal-companycreate-close-trigger')

    Array.from(modalCompanycreateOpenTriggers).forEach(trigger => {
        trigger.addEventListener('click', () => CNS.$modals.openModal('.js-modal-companycreate', trigger, true, true))
    })

    Array.from(modalCompanycreateCloseTriggers).forEach(trigger => {
        trigger.addEventListener('click', () => CNS.$modals.closeModal('.js-modal-companycreate', trigger))
    })

    // Send documents
    CNS.$fns.openModalSendDocuments = () => {
        CNS.$modals.openModal('.js-modal-send-documents', null)
    }

    CNS.$fns.closeModalSendDocuments = () => {
        CNS.$modals.closeModal('.js-modal-send-documents')
    }

    const modalSendDocumentsOpenTriggers = document.querySelectorAll('.js-modal-send-documents-open-trigger')
    const modalSendDocumentsCloseTriggers = document.querySelectorAll('.js-modal-send-documents-close-trigger')

    Array.from(modalSendDocumentsOpenTriggers).forEach(trigger => {
        trigger.addEventListener('click', () => CNS.$modals.openModal('.js-modal-send-documents', trigger))
    })

    Array.from(modalSendDocumentsCloseTriggers).forEach(trigger => {
        trigger.addEventListener('click', () => CNS.$modals.closeModal('.js-modal-send-documents', trigger))
    })

    // Send documents
    CNS.$fns.openModalLeadCancel = () => {
        CNS.$modals.openModal('#modal-lead-cancel', null, true, true)
    }

    CNS.$fns.closeModalLeadCancel = () => {
        CNS.$modals.closeModal('#modal-lead-cancel')
    }

    $$('.js-modal-lead-cancel-closer').forEach(closer => {
        closer.addEventListener('click', event => {
            event.preventDefault()
            CNS.$fns.closeModalLeadCancel()
        })
    })

    // Modal confrim lead orders
    CNS.$fns.openModalConfirmLeadOrder = () => {
        CNS.$modals.openModal('#modal-confirm-lead-order', null, true, true)
    }

    CNS.$fns.closeModalConfirmLeadOrder = () => {
        CNS.$modals.closeModal('#modal-confirm-lead-order')
    }

    $$('.js-modal-confirm-lead-order-closer').forEach(closer => {
        closer.addEventListener('click', event => {
            event.preventDefault()
            CNS.$fns.closeModalConfirmLeadOrder()
        })
    })

    // Modal show files
    CNS.$fns.openModalShowFile = () => {
        CNS.$modals.openModal('#modal-show-file', null, true, true)
    }

    CNS.$fns.closeModalShowFile = () => {
        CNS.$modals.closeModal('#modal-show-file')
    }

    $$('.js-modal-show-file-closer').forEach(closer => {
        closer.addEventListener('click', event => {
            event.preventDefault()
            CNS.$fns.closeModalShowFile()
        })
    })

    // Modal view content file
    CNS.$fns.openModalViewFileContent = () => {
        CNS.$modals.openModal('#modal-view-file-content', null, true, true)
    }

    CNS.$fns.closeModalViewFileContent = () => {
        CNS.$modals.closeModal('#modal-view-file-content')
    }

    $$('.js-modal-view-file-content-closer').forEach(closer => {
        closer.addEventListener('click', event => {
            event.preventDefault()
            CNS.$fns.closeModalViewFileContent()
        })
    })

    // Modal manage contract
    CNS.$fns.openModalManageContract = () => {
        CNS.$modals.openModal('#modal-manage-contract', null, true, true)
    }

    CNS.$fns.closeModalManageContract = () => {
        CNS.$modals.closeModal('#modal-manage-contract')
    }

    $$('.js-modal-manage-contract-closer').forEach(closer => {
        closer.addEventListener('click', event => {
            event.preventDefault()
            CNS.$fns.openModalManageContract()
        })
    })

    // Modal manage contragent
    CNS.$fns.openModalManageContragent = () => {
        CNS.$modals.openModal('#modal-manage-contragent', null, true, true)
    }

    CNS.$fns.closeModalManageContragent = () => {
        CNS.$modals.closeModal('#modal-manage-contragent')
    }

    $$('.js-modal-manage-contragent-closer').forEach(closer => {
        closer.addEventListener('click', event => {
            event.preventDefault()
            CNS.$fns.openModalManageContragent()
        })
    })

    // Modal sign file
    CNS.$fns.openModalSignFile = () => {
        CNS.$modals.openModal('#modal-sign-file', null, true, true)
    }

    CNS.$fns.closeModalSignFile = () => {
        CNS.$modals.closeModal('#modal-sign-file')
    }

    $$('.js-modal-sign-file-closer').forEach(closer => {
        closer.addEventListener('click', event => {
            event.preventDefault()
            CNS.$fns.openModalSignFile()
        })
    })

    // Modal confrim document account
    CNS.$fns.openModalConfirmDocumentAccount = () => {
        CNS.$modals.openModal('#modal-confirm-document-account', null, true, true)
    }

    CNS.$fns.closeModalConfirmDocumentAccount = () => {
        CNS.$modals.closeModal('#modal-confirm-document-account')
    }

    $$('.js-modal-confirm-document-account-closer').forEach(closer => {
        closer.addEventListener('click', event => {
            event.preventDefault()
            CNS.$fns.closeModalConfirmDocumentAccount()
        })
    })

    // Modal confrim document act
    CNS.$fns.openModalConfirmDocumentAct = () => {
        CNS.$modals.openModal('#modal-confirm-document-act', null, true, true)
    }

    CNS.$fns.closeModalConfirmDocumentAct = () => {
        CNS.$modals.closeModal('#modal-confirm-document-act')
    }

    $$('.js-modal-confirm-document-act-closer').forEach(closer => {
        closer.addEventListener('click', event => {
            event.preventDefault()
            CNS.$fns.closeModalConfirmDocumentAct()
        })
    })

    // Modal confrim document expense certificate
    CNS.$fns.openModalConfirmDocumentExpenseCertificate = () => {
        CNS.$modals.openModal('#modal-confirm-document-expense-certificate', null, true, true)
    }

    CNS.$fns.closeModalConfirmDocumentExpenseCertificate = () => {
        CNS.$modals.closeModal('#modal-confirm-document-expense-certificate')
    }

    $$('.js-modal-confirm-document-expense-certificate-closer').forEach(closer => {
        closer.addEventListener('click', event => {
            event.preventDefault()
            CNS.$fns.closeModalConfirmDocumentExpenseCertificate()
        })
    })

    // Estimate company
    CNS.$fns.openModalEstimateCompany = () => {
        CNS.$modals.openModal('#js-modal-estimate-company', null, true, true)
    }

    CNS.$fns.closeModalEstimateCompany = () => {
        CNS.$modals.closeModal('#js-modal-estimate-company')
    }

    $$('.js-modal-estimate-company-close-trigger').forEach(closer => {
        closer.addEventListener('click', event => {
            event.preventDefault()
            CNS.$fns.closeModalEstimateCompany()
        })
    })


    // Company delivery
    CNS.$fns.openModalCompanyDelivery = () => {
        CNS.$modals.openModal('#js-modal-company-delivery', null, true, true)
    }

    CNS.$fns.closeModalCompanyDelivery = () => {
        CNS.$modals.closeModal('#js-modal-company-delivery')
    }

    $$('.js-modal-company-delivery-close-trigger').forEach(closer => {
        closer.addEventListener('click', event => {
            event.preventDefault()
            CNS.$fns.closeModalCompanyDelivery()
        })
    })

    // Adr sets
    CNS.$fns.openModalAdrSets = () => {
        CNS.$modals.openModal('#modal-adr-sets', null, true, true)
    }

    CNS.$fns.closeModalAdrSets = () => {
        CNS.$modals.closeModal('#modal-adr-sets')
    }

    const modalAdrSetsOpenTriggers = document.querySelectorAll('.js-modal-adr-sets-open-trigger')
    const modalAdrSetsCloseTriggers = document.querySelectorAll('.js-modal-adr-sets-close-trigger')

    Array.from(modalAdrSetsOpenTriggers).forEach(trigger => {
        trigger.addEventListener('click', () => CNS.$modals.openModal('#modal-adr-sets', trigger, true, true))
    })

    Array.from(modalAdrSetsCloseTriggers).forEach(trigger => {
        trigger.addEventListener('click', () => CNS.$modals.closeModal('#modal-adr-sets', trigger))
    })

    // Company analytics filter
    CNS.$fns.openModalCompanyAnalyticsFilter = () => {
        CNS.$modals.openModal('#modal-company-analytics-filter', null, true, true)
    }

    CNS.$fns.closeModalCompanyAnalyticsFilter = () => {
        CNS.$modals.closeModal('#modal-company-analytics-filter')
    }

    const modalCompanyAnalyticsFilterOpenTriggers = document.querySelectorAll('.js-modal-company-analytics-filter-open-trigger')
    const modalCompanyAnalyticsFilterCloseTriggers = document.querySelectorAll('.js-modal-company-analytics-filter-close-trigger')

    modalCompanyAnalyticsFilterOpenTriggers.forEach(trigger => {
        trigger.addEventListener('click', () => CNS.$modals.openModal('#modal-company-analytics-filter', trigger, true, true))
    })

    modalCompanyAnalyticsFilterCloseTriggers.forEach(trigger => {
        trigger.addEventListener('click', () => CNS.$modals.closeModal('#modal-company-analytics-filter', trigger))
    })

    // Companies list crm filter
    CNS.$fns.openModalCompaniesListCrmFilter = () => {
        CNS.$modals.openModal('#modal-companies-list-crm-filter', null, true, true)
    }

    CNS.$fns.closeModalCompaniesListCrmFilter = () => {
        CNS.$modals.closeModal('#modal-companies-list-crm-filter')
    }

    const modalCompaniesListCrmFilterOpenTriggers = document.querySelectorAll('.js-modal-companies-list-crm-filter-open-trigger')
    const modalCompaniesListCrmFilterCloseTriggers = document.querySelectorAll('.js-modal-companies-list-crm-filter-close-trigger')

    modalCompaniesListCrmFilterOpenTriggers.forEach(trigger => {
        trigger.addEventListener('click', () => CNS.$modals.openModal('#modal-companies-list-crm-filter', trigger, true, true))
    })

    modalCompaniesListCrmFilterCloseTriggers.forEach(trigger => {
        trigger.addEventListener('click', () => CNS.$modals.closeModal('#modal-companies-list-crm-filter', trigger))
    })


    // Lead delivery
    CNS.$fns.openModalLeadDelivery = () => {
        CNS.$modals.openModal('#js-modal-lead-delivery', null, true, true)
    }

    CNS.$fns.closeModalLeadDelivery = () => {
        CNS.$modals.closeModal('#js-modal-lead-delivery')
    }

    $$('.js-modal-lead-delivery-close-trigger').forEach(closer => {
        closer.addEventListener('click', event => {
            event.preventDefault()
            CNS.$fns.closeModalLeadDelivery()
        })
    })

    // Lead receiving
    CNS.$fns.openModalLeadReceiving = () => {
        CNS.$modals.openModal('#js-modal-lead-receiving', null, true, true)
    }

    CNS.$fns.closeModalLeadReceiving = () => {
        CNS.$modals.closeModal('#js-modal-lead-receiving')
    }

    $$('.js-modal-lead-receiving-close-trigger').forEach(closer => {
        closer.addEventListener('click', event => {
            event.preventDefault()
            CNS.$fns.closeModalLeadReceiving()
        })
    })

    // Send emails
    CNS.$fns.openModalSendEmails = () => {
        CNS.$modals.openModal('#js-modal-send-emails', null, true, true)
    }

    CNS.$fns.closeModalSendEmails = () => {
        CNS.$modals.closeModal('#js-modal-send-emails')
    }

    $$('.js-modal-send-emails-close-trigger').forEach(closer => {
        closer.addEventListener('click', event => {
            event.preventDefault()
            CNS.$fns.closeModalSendEmails()
        })
    })
})(CNS)
